import api from "./api";

export const addTradeApproval = async (trade: any): Promise<any> => {
  const { data } = await api.post("/admin/tradeApprovals", {
    tradeId: trade.id,
  });

  return data.approval;
};
